import React from "react";
import { FormattedMessage } from "react-intl";
import { useContactus } from "../../redux/hooks/hooks";

const ContactInfo = () => {
    const data = useContactus();

    return (
        <div className="w-full flex flex-col gap-y-6 md:px-2">
            <div className="bg-white rounded-xl shadow-md p-6">
                <h3 className="font-bold text-xl text-[#0a1628] mb-4 font-noedisplay">{data?.name}</h3>
                <hr className="w-12 h-1 bg-[#16A34A] mb-4" />
                <div className="pt-2">
                    <div className="pb-4">
                        <h4 className="font-bold text-[#16A34A] mb-3 font-arial">Contacts</h4>
                    </div>
                    <div className="space-y-3">
                        <div className="flex items-start gap-3">
                            <span className="font-bold text-[#16A34A]">Tél:</span>
                            <span className="text-gray-700 font-arial">{data?.phone}</span>
                        </div>
                        <div className="flex items-start gap-3">
                            <span className="font-bold text-[#16A34A]">Fax:</span>
                            <span className="text-gray-700 font-arial">{data?.fax}</span>
                        </div>
                        <div className="flex items-start gap-3">
                            <span className="font-bold text-[#16A34A]">Email:</span>
                            <p className="text-gray-700 font-arial break-all">{data?.email}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6">
                <h4 className="font-bold text-lg text-[#0a1628] mb-4 font-noedisplay">
                    <FormattedMessage id="office.address" />
                </h4>
                <div className="space-y-3">
                    <div className="flex flex-col gap-2">
                        <span className="text-gray-700 font-arial">{data?.address}</span>
                        <span className="text-gray-700 font-arial">{data?.postBox}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactInfo;
